import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  label: {
    description: 'Font color label',
    defaultMessage: 'Font Color',
    id: 'u9j4h0',
  },
  black: {
    description: 'Black font color option',
    defaultMessage: 'Black',
    id: 'FNzt76',
  },
  grey: {
    description: 'Grey font color option',
    defaultMessage: 'Grey',
    id: 'LZcQsO',
  },
  red: {
    description: 'Red font color option',
    defaultMessage: 'Red',
    id: 'dYL9EB',
  },
});
